// // Use $ instead of jQuery without replacing global $
(function ($) {
  // var column_grid_image = $('body .column-grid .grid-outer .card .inner-wrap .bg-img img');
  // objectFitImages(column_grid_image);


  //global variables
  var slideBox = $('.column-grid .grid-outer .card .content-overlay');
  var parentDiv = $('.column-grid .grid-outer .card');
  var containerWidth = $('.column-grid .container').width();
  var flag = false;

  //On click overlay open code starts here
  // if ($('.column-grid').length) {

  $('.column-grid .grid-outer .card .inner-wrap').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    var windowWidth = $(window).width();

    var $this = $(this);
    var currentOpen = $($this).offset().top;
    var preOffset = ($('.column-grid .grid-outer .card.current').length > 0) ? $('.column-grid .grid-outer .card.current').offset().top : 0;

    if ($this.parent().hasClass('current')) {
      setTimeout(function () {
        $(parentDiv).removeClass('current');
      }, 500);
      $(slideBox).stop(true, true).slideUp(300);
    } else {
      $(parentDiv).removeClass('current');
      $(this).parent().addClass('current');
      if (currentOpen !== preOffset) {
        $(slideBox).stop(true, true).slideUp(500);
      }
      $(slideBox).stop(true, true).slideUp(300);
      $(this).parent().find('.content-overlay').slideDown(500);
      // $('.column-grid .grid-outer .card .content-overlay .inner-div').css({'opacity': '1', 'transition-delay': '0.7s'});
    }

    //On click overlay arrow code starts
    var offsetLeftBox = $($this).parents('.card').offset().left;   // left offset of current clicked card
    var containerOffsetLeft = $('body .column-grid .grid-outer .card:eq(0)').offset().left;     //Left offset of card which has index value 0
    var parentDivWidth = $('.column-grid .grid-outer .card').width() / 2;     // divide the width of card(box) by 2 for setting position of arrow

    //set position of arrow over the Overlay
    $(this).parents('.card').find('.content-overlay .active-arrow').css({
      'left': offsetLeftBox - containerOffsetLeft + parentDivWidth - 25 + 'px'
    });

    setTimeout(function () {
      if (windowWidth < 768) {
        var content = $('body .column-grid .grid-outer .card.current');
        $('html, body').animate({
          'scrollTop': $(content).offset().top - 69
        }, 800, 'swing');
      }
    }, 100);

  });


  $('.column-grid .grid-outer .card .content-overlay .inner-div .close-icon').on('click', function (e) {
    e.stopPropagation();
    $('.column-grid .grid-outer .card .content-overlay').slideUp(500);
  });


  $('.column-grid.paragraph').find('.card').unwrap().unwrap();

  //Set overlay from Left with Each function on DOM ready
  $(document).ready(function () {
    if ($('body .column-grid .grid-outer .card').length > 0) {
      var containerOffsetLeft = $('body .column-grid .grid-outer .card:eq(0)').offset().left;
      $('.column-grid .grid-outer .card').each(function (index, value) {
        var offsetLeft = $(value).offset().left;
        $(value).find('.content-overlay').css({
          'left': (containerOffsetLeft - offsetLeft)
        });
      });
    }
  });

  //Set overlay from Left with Each function on window load
  $(window).on('load', function () {
    if ($('body .column-grid .grid-outer .card').length > 0) {
      var containerOffsetLeft = $('body .column-grid .grid-outer .card:eq(0)').offset().left;
      $('.column-grid .grid-outer .card').each(function (index, value) {
        var offsetLeft = $(value).offset().left;
        $(value).find('.content-overlay').css({
          'left': (containerOffsetLeft - offsetLeft)
        });
      });
    }
  });


  $(window).resize(function (e) {
    if ($('body .column-grid .grid-outer .card').length > 0) {
      var containerWidth = $('.column-grid .container').width();
      var containerWidth1 = $('.column-grid.grid-five .container .grid-outer').width();
      var containerOffsetLeft = $('body .column-grid .grid-outer .card:eq(0)').offset().left;
      var winWidth = $(window).width();

      // assign width to overlay of home page (grid-five)
      if ($('.column-grid').hasClass('grid-five')) {
        flag = true;
      }
      if (flag) {
        if (winWidth > 1200) {
          $(slideBox).css({'width': containerWidth1 + 'px'});
        } else {
          $(slideBox).css({'width': containerWidth + 'px'});
        }
      } else {
        $(slideBox).css({
          'width': containerWidth + 'px'
        });
      }

      //Set overlay from Left with Each function on window resize
      $('.column-grid .grid-outer .card').each(function (index, value) {
        var offsetLeft = $(value).offset().left;
        $(value).find('.content-overlay').css({
          'left': (containerOffsetLeft - offsetLeft)
        });
      });
    }

  });


  $(slideBox).on('click', function (e) {
    e.stopPropagation();
    // e.preventDefault();
  });

  $(document).on('click', function (e) {
    e.stopPropagation();
    $(parentDiv).removeClass('current');
    $(slideBox).stop(true, true).slideUp(500);
  });

  $('.column-grid .grid-outer .card .content-overlay .inner-div .close-icon').on('click', function (e) {
    e.stopPropagation();
    setTimeout(function () {
      $(parentDiv).removeClass('current');
    }, 300);
    $(this).parents('.card').find('.column-grid .grid-outer .card .content-overlay').slideUp(500);
    // $(slideBox).stop(true, true).slideUp(500);
  });
  // }


  if ($('.column-grid').length > 0) {
    /* Load more click count. */
    var item_show = 6,
        length = '',
        product_item_show = 6,
        product_length = '',
        solution_item_show = 6,
        solution_length = '';

    /* Function to hide and show element on Load */
    function load_OnReady_column() {
      if($('.index-grid').length > 0) {

      } else {
        $('.column-grid .grid-outer').find('.card').each(function () {
          length = $(this).parents('.column-grid .grid-outer').find('.card').length;
          // console.log(length);
          var index = $(this).index();
          if (index >= item_show) {
            $(this).css('display', 'none').removeClass('active-filter');
          } else {
            $(this).css('display', 'block').addClass('active-filter');
          }
          if (length <= item_show) {
            $(this).parents('.column-grid').find('.load-more').css('display', 'none');
          } else {
            $(this).parents('.column-grid').find('.load-more').css('display', 'inline-block');
          }
        });
      }
    }

    // For product index
    function load_OnReady_product() {
      $('.product-paragraph .grid-outer').find('.card').each(function () {
        product_length = $(this).parents('.product-paragraph .grid-outer').find('.card').length;
        // console.log(product_length);
        var index = $(this).index();
        if (index >= product_item_show) {
          $(this).css('display', 'none').removeClass('active-filter');
        } else {
          $(this).css('display', 'block').addClass('active-filter');
        }
        if (product_length <= product_item_show) {
          $(this).parents('.product-paragraph').find('.product-load-more').css('display', 'none');
        } else {
          $(this).parents('.product-paragraph').find('.product-load-more').css('display', 'inline-block');
        }
      });
    }

    // For solution index
    function load_OnReady_solution() {
      $('.solution-paragraph .grid-outer').find('.card').each(function () {
        solution_length = $(this).parents('.solution-paragraph .grid-outer').find('.card').length;
        // console.log(solution_length);
        var index = $(this).index();
        if (index >= item_show) {
          $(this).css('display', 'none').removeClass('active-filter');
        } else {
          $(this).css('display', 'block').addClass('active-filter');
        }
        if (solution_length <= solution_item_show) {
          $(this).parents('.solution-paragraph').find('.solution-load-more').css('display', 'none');
        } else {
          $(this).parents('.solution-paragraph').find('.solution-load-more').css('display', 'inline-block');
        }
      });
    }

    /* Function to show element on Load more click */
    function loadMore_column() {
      if($('.index-grid').length > 0) {

      } else {
        var $i = 0;
        $('.column-grid .grid-outer .card').each(function () {
          var $dataDisplay = $(this).css('display');
          if ($dataDisplay == 'block') {
            $i++;
          }
        });
        if ($i < length) {
          for (var $j = $i; $j < ($i + item_show); $j++) {
            // $('.column-grid .grid-outer .card').eq($j).css({'display': 'block'});
            $('.column-grid .grid-outer .card').css({'display': 'block'});
            $('.column-grid .load-more').css({'display': 'none'});

            if (($i + item_show) >= length) {
              $('.column-grid .load-more').css({'display': 'none'});
            }
          }
        } else {
          $('.column-grid .load-more').css({'display': 'none'});
        }
      }
    }

    var f = 0, f1 = 0;

    var grid_geo;

    function column_grid_geo() {
      if ($('.column-grid.partners').length > 0) {
        $('.column-grid.grid-three .grid-outer .card .inner-wrap .bg-img').each(function (index) {
          // console.log(this, index);
          var data;
          data = $(this).attr('data-region');
          $('.column-grid.grid-three .grid-outer .card:eq(' + index + ')').addClass(data);
        });

        setTimeout(function () {
          grid_geo = $('body').attr('data-region');

          $('.column-grid .grid-outer .card').each(function () {
            $(this).removeClass('New');

            if ($(this).hasClass('Australia') || $(this).hasClass('India') || $(this).hasClass('Africa') || $(this).hasClass('Zealand')) {
              $(this).removeClass('all');
            }

            if ($(this).hasClass('Australia') && (grid_geo === 'australia') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else if ($(this).hasClass('Zealand') && (grid_geo === 'new_zealand') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else if ($(this).hasClass('India') && (grid_geo === 'in') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else if ($(this).hasClass('Africa') && (grid_geo === 'africa') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else {
              $(this).remove();
            }
          });
        }, 500);
      }

      if ($('.column-grid.product-tier-one').length > 0) {
        setTimeout(function () {
          grid_geo = $('body').attr('data-region');

          $('.column-grid .grid-outer .card').each(function () {
            $(this).removeClass('New');

            if ($(this).hasClass('Australia') && (grid_geo === 'australia') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else if ($(this).hasClass('Zealand') && (grid_geo === 'new_zealand') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else if ($(this).hasClass('India') && (grid_geo === 'in') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else if ($(this).hasClass('Africa') && (grid_geo === 'africa') || $(this).hasClass('all')) {
              $(this).addClass('active');

            } else {
              $(this).remove();
            }
          });
        }, 500);
      }
    }


    $(document).ready(function () {
      limit_lines('body .column-grid.grid-three .grid-outer .card .inner-wrap .card-body h5', 2);

      column_grid_geo();
    });

    $(window).on('resize', function () {
      var winWidth = $(window).width();
      if (winWidth < 768) {
        if (f1 == 0) {
          load_OnReady_column();

          load_OnReady_product();
          load_OnReady_solution();
          f1 = 1;
        }
      }

      limit_lines('body .column-grid.grid-three .grid-outer .card .inner-wrap .card-body h5', 2);
    });

    $(document).on('click', '.column-grid .load-more', function () {
      loadMore_column();

      $('.column-grid .grid-outer .card').each(function (index, value) {
        var containerOffsetLeft = $('body .column-grid .grid-outer .card:eq(0)').offset().left;
        var offsetLeft = $(value).offset().left;
        $(value).find('.content-overlay').css({
          'left': (containerOffsetLeft - offsetLeft)
        });
      });

    });

    // For product index
    function product_index_loadmore() {
      var $i = 0;
      $('.product-paragraph .grid-outer .card').each(function () {
        var $dataDisplay = $(this).css('display');
        if ($dataDisplay == 'block') {
          $i++;
        }
      });
      if ($i < product_length) {
        for (var $j = $i; $j < ($i + product_item_show); $j++) {
          // $('.column-grid .grid-outer .card').eq($j).css({'display': 'block'});
          $('.product-paragraph .grid-outer .card').css({'display': 'block'});
          $('.product-paragraph .product-load-more').css({'display': 'none'});
          if (($i + product_item_show) >= product_length) {
            $('.product-paragraph .product-load-more').css({'display': 'none'});
          }
        }
      } else {
        $('.product-paragraph .product-load-more').css({'display': 'none'});
      }
    }

    // For solution index
    function solution_index_loadmore() {
      var $i = 0;
      $('.solution-paragraph .grid-outer .card').each(function () {
        var $dataDisplay = $(this).css('display');
        if ($dataDisplay == 'block') {
          $i++;
        }
      });
      if ($i < solution_length) {
        for (var $j = $i; $j < ($i + solution_item_show); $j++) {
          // $('.column-grid .grid-outer .card').eq($j).css({'display': 'block'});
          $('.solution-paragraph .grid-outer .card').css({'display': 'block'});
          $('.solution-paragraph .solution-load-more').css({'display': 'none'});
          if (($i + solution_item_show) >= solution_length) {
            $('.solution-paragraph .solution-load-more').css({'display': 'none'});
          }
        }
      } else {
        $('.solution-paragraph .solution-load-more').css({'display': 'none'});
      }
    }

    $(document).on('click', '.column-grid .product-load-more', function () {
      product_index_loadmore();
    });
    $(document).on('click', '.column-grid .solution-load-more', function () {
      solution_index_loadmore();
    });
  }


  $(window).on('load', function () {
    var winWidth = $(window).width();
    if (winWidth < 768) {
      if (f === 0) {
        setTimeout(function () {
          load_OnReady_column();

          load_OnReady_product();
          load_OnReady_solution();
          f = 1;
        }, 1500);
      }
    }
  });

  $(document).ready(function () {
    var column_grid = $('.column-grid .grid-outer .card .inner-wrap .bg-img img');
    objectFitImages(column_grid);
  });

})(jQuery);

